import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import EventCardTicket from '../../Components/Events/eventCardTicket'
import axios from 'axios'; import Modal from 'react-responsive-modal';
import {connect} from 'react-redux';
import NumberFormat from 'react-number-format';
import moment from 'moment';
import {StyleSheet, css} from 'aphrodite';

const getState = (state) =>{
    return{
        url:state.url
    }
}

const cookies = new Cookies();

class MemberTickets extends Component {
    constructor(){
        super()
        this.state = {
            events:[],
            reservations:[],
            seats:[],
            open:false,
            activeEvent:'',
            activeReservation: ''
        }
    }

    componentWillMount = () => {
        let url = this.props.url
        // let funcion = this.props.loadCurrentEvent
        axios.get(url + '/api/v1/reservations/orders/?user=' + cookies.get('key'))
            .then(response => {
                let events = []
                let reservations = response.data
                let band = 0
                for(let x in response.data){
                    band= 0
                    for(let i = 0; i<events.length;i++){
                        if(events[i].id===response.data[x].event.id){
                            band =1
                        }
                    }
                    if(band === 0) events.push(response.data[x].event)
                }
                this.setState({events, reservations })
            })  
            .catch(err => {
                console.log(err)
            })
    }

    onCloseModal = () =>{
        this.setState({open:false})
    }
    onOpenModal = () => {
        this.setState({ open: true })
    }

    selectEvent = (index) =>{
        this.setState({
            activeEvent:this.state.events[index].id
        },
            console.log(this.state.activeEvent, this.state.events[index].id))
    }
    getSeats = (e) =>{
        let url = this.props.url
        let index = e.target.getAttribute('data-index')
        axios.get(url + '/api/v1/reservations/get/seats/' + this.state.reservations[index].id+'/')
        .then(response =>{
            console.log(response.data)
            this.setState({
                activeReservation: index,
                seats: response.data
            })
        })
        .catch(err =>{
            console.log(err)
        })
    }
    render() {
        return (
            <div className="col-sm-9 reservations-member">
                <div className={css(styles.titleContainer)}>
                    <h4 className={css(styles.titleStyle)}>Mis Boletas</h4>
                </div>
                {this.state.events.length>0
                ?
                    this.state.events.map((el, key) =>
                        <EventCardTicket name={el.name}
                            key={key}
                            capacity={el.max_capacity}
                            featuredImage={this.props.url + el.featured_image}
                            available={el.available}
                            openModalTicket={this.onOpenModal}
                            selectEvent = {this.selectEvent}
                            index={key}>
                            {`${el.description.substring(0, 260)}..`}
                        </EventCardTicket>
                    )
                    :
                    <h5 className='py-4 my-4'>Aun no tienes reservaciones disponibles!</h5>
                }
                <Modal open={this.state.open} onClose={this.onCloseModal} classNames={{ overlay: 'custom-overlay', modal: 'custom-modal' }} center closeIconSize={20}>
                    <div className="row">
                        <div className="col-12 text-center">
                                <h4 className="mb-4">Listado de Reservaciones</h4>
                                {this.state.reservations.map((el,key)=>{
                                    let arr = []
                                    let cero = ''
                                    for(let i=0;i<7-String(el.id).length;i++){
                                        cero+='0'
                                    }
                                    if(el.event.id === this.state.activeEvent){
                                        arr.push(<div className="row " key={key}>
                                            <div className="col-10 offset-1">
                                                <div className="row ">
                                                    <div className="col-12 py-2  reservation-content">
                                                    <span className='detailTicket'>Nro. Orden: {cero}{el.id}</span>
                                                    <span className='detailTicket'>Fecha de Compra: {moment(el.date).format('DD-MM-YYYY')}</span>
                                                    <span className='detailTicket'>Pago: RD$ <NumberFormat thousandSeparator={true} displayType={'text'} value={el.amount_paid } /></span>
                                                    <span className='detailTicket'><a data-index={key} onClick={this.getSeats} className="show-more">Detalle</a></span>
                                                    </div>
                                                </div>
                                                <div className='col-12 content-seats-reservation'>
                                                {parseInt(this.state.activeReservation) === parseInt(key)
                                                ?
                                                <div className='col-12'>
                                                  <div className="row ">
                                                            <div  className="col-12 py-2 header-tickets-reservated">
                                                            <span className='detailTicket' >Taquilla</span>
                                                            <span className='detailTicket' >Asiento</span>
                                                            <span className='detailTicket' >Precio</span>
                                                            <span className='detailTicket' >Tipo</span>
                                                        </div>
                                                    </div>
                                                 {this.state.seats.map((el2,key2)=>
                                                    <div className="row " key={key2}>
                                                            <div  className="col-12 py-2 ">
                                                            <span className='detailTicket' >{el2.ticket_name.name}</span>
                                                            <span className='detailTicket' ><strong>{el2.name_seat}</strong></span>
                                                            <span className='detailTicket' >RD$ <NumberFormat thousandSeparator={true} displayType={'text'} value={el2.price} /></span>
                                                            <span className='detailTicket' >
                                                            {el2.invited ? "Invitado" : "Socio"}
                                                            </span>
                                                        </div>
                                                    </div>
                                                   
                                                 )}
                                                  </div>
                                                :
                                                null
                                                }
                                                </div>
                                            </div>
                                        </div>)
                                       }
                                       return arr
                                    }
                                )}
                        </div>
                        <div className="col-12 py-3 my-3 text-center">
                        </div>
                    </div>
                            <a onClick={this.onCloseModal}  className="btn btn-events btn-reservations">Cerrar</a>
                </Modal>
            </div>
        );
    }
}

const styles = StyleSheet.create({
    titleContainer: {
        marginTop: '1rem',
        textAlign: 'center',
    },
    titleStyle: {
        fontWeight: '700',
    }
})

export default connect(getState,null)(MemberTickets);


// WEBPACK FOOTER //
// ./src/Pages/MemberTickets/index.js